import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledToastButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}
    background-color: ${({ theme }) =>
        theme.components.lyt_button.toast.background.default};
    color: ${({ theme }) => theme.components.lyt_button.toast.text.default};
    border: none;
    text-decoration: none;

    &:hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast.background.default};
        color: ${({ theme }) => theme.components.lyt_button.toast.text.hover};
        text-decoration: underline;
    }

    &:active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast.background.default};
        color: ${({ theme }) => theme.components.lyt_button.toast.text.pressed};
        text-decoration: underline;
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast.background.default};
        outline: 2px solid
            ${({ theme }) => theme.components.lyt_button.toast.border.outline};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.toast.text.disabled};
        cursor: not-allowed;
        text-decoration: none;
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.toast.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.toast.text.selected};
        text-decoration: underline;
    }
`;
const LytToastButton = ({ isCompact = false, ...props }) => {
    return <StyledToastButton isCompact={isCompact} {...props} />;
};
LytToastButton.propTypes = {
    isCompact: PropTypes.bool,
};
export default LytToastButton;
